"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var InitialiseEditorModules_1 = __importDefault(require("./InitialiseEditorModules"));
var HtmlTokenizer_1 = __importDefault(require("./Conversion/HtmlTokenizer"));
var ErrorBoundary_1 = require("./ErrorBoundary");
var SlateEditor_1 = __importDefault(require("./SlateEditor"));
var Deserialise_1 = require("./Tokenization/Deserialise");
var ShowImagePicker_1 = __importDefault(require("./ShowImagePicker"));
var QwilrEditorTelemetry_1 = __importDefault(require("./QwilrEditorTelemetry"));
var QwilrEditorComponent = (function (_super) {
    __extends(QwilrEditorComponent, _super);
    function QwilrEditorComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.showLoadingSpinner = false;
        _this.maybeRenderLoader = function () {
            if (_this.isLoading && _this.showLoadingSpinner) {
                return react_1.default.createElement("div", { className: "circle-loader" });
            }
        };
        _this.maybeRenderEditor = function () {
            if (!_this.isLoading) {
                var projectStore = _this.di.get("projectStore");
                return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { modal: _this.props.modal, errorRecorder: _this.errorRecorder },
                    react_1.default.createElement(SlateEditor_1.default, { saver: _this.saver, router: _this.router, loader: _this.loader, initialState: (0, Deserialise_1.deserialise)(_this.model.tokens), editorElem: _this.editorContainerRef, showImagePicker: _this.showImagePicker, configuration: _this.configurationObject, cursorValidator: _this.cursorValidator, usingFeature: _this.usingFeature, conversionElem: _this.conversionAreaRef, di: _this.di, blockStore: _this.di.get("blockStore"), brandStore: _this.di.get("brandStore"), stylePermissionStore: _this.di.get("stylePermissionStore"), uploadStore: _this.di.get("uploadStore"), commentThreadStore: _this.di.get("commentThreadStore"), videoEmbedUrlGenerator: _this.di.get("videoEmbedUrlGenerator"), projectStore: projectStore, blockList: _this.di.get("blockList") })));
            }
        };
        _this.conversionAreaRef = react_1.default.createRef();
        _this.editorContainerRef = react_1.default.createRef();
        var di = props.di, usingFeature = props.usingFeature, block = props.block, model = props.model, configuration = props.configuration;
        var _a = (0, InitialiseEditorModules_1.default)(di, usingFeature, block, model, configuration), configurationObject = _a.configurationObject, router = _a.router, errorRecorder = _a.errorRecorder, saver = _a.saver, loader = _a.loader, cursorValidator = _a.cursorValidator;
        _this.configurationObject = configurationObject;
        _this.router = router;
        _this.model = model;
        _this.errorRecorder = errorRecorder;
        _this.saver = saver;
        _this.loader = loader;
        _this.showImagePicker = di.invoke(ShowImagePicker_1.default);
        _this.cursorValidator = cursorValidator;
        _this.usingFeature = usingFeature;
        _this.di = di;
        var editorTelemetry = "editorTelemetry";
        if (!di.has(editorTelemetry)) {
            di.value(editorTelemetry, di.make(QwilrEditorTelemetry_1.default));
        }
        return _this;
    }
    QwilrEditorComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.di.convoke(this.configurationObject.registerBehaviours, null, {
            router: this.router,
            getConversionElem: function () {
                return _this.conversionAreaRef.current;
            },
        });
        if (this.model.tokens == undefined) {
            this.conversionAreaRef.current.innerHTML = this.model.content;
            var converter = new HtmlTokenizer_1.default();
            var tokens = converter.tokenize(this.conversionAreaRef.current, this.model.widgets);
            this.model.tokens = tokens;
        }
    };
    QwilrEditorComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "editor-v1" },
            this.maybeRenderLoader(),
            react_1.default.createElement("div", { ref: this.editorContainerRef }, this.maybeRenderEditor()),
            react_1.default.createElement("div", { className: "conversion-area", ref: this.conversionAreaRef, tabIndex: -1 })));
    };
    Object.defineProperty(QwilrEditorComponent.prototype, "isLoading", {
        get: function () {
            return this.model.tokens == undefined;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QwilrEditorComponent.prototype, "showLoadingSpinner", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], QwilrEditorComponent.prototype, "model", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QwilrEditorComponent.prototype, "isLoading", null);
    QwilrEditorComponent = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], QwilrEditorComponent);
    return QwilrEditorComponent;
}(react_1.default.Component));
exports.default = QwilrEditorComponent;
